import React, { useRef } from "react";
import ReactSelect from "react-select";

import { selectStyle, selectTheme } from "./settings";
import { useNormalizer, WpTermToSelectOption } from "../utils";

/**
 * Configuration
 */
import config from "../config";

const { blockClassName, icons } = config;

const LayoutSelect = ({
	label,
	placeholder,
	options,
	selected,
	setSelected,
}) => {
	return (
		<div className="layout-select">
			<div className="layout-select__label input-label">{label}</div>

			{options.map((item, key) => (
				<button
					className={`${
						selected.includes(item.id) ? "is-active " : ""
					}layout-select__item button`}
					onClick={() => setSelected([item.id])}
					key={key}
				>
					<span
						dangerouslySetInnerHTML={{
							__html: icons[item.id],
						}}
					/>
					{item.title}
				</button>
			))}
		</div>
	);
};

export default LayoutSelect;
